module.exports = "<div class=\"drzStorm-container\">\n  <router-view></router-view>\n  <div id=\"drzTooltip-container\"></div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/storm/template.html
// module id = BqWA
// module chunks = 0